import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import axios from "axios";
import "../../../src/assets/css/App.css";
import { message } from 'antd';
import { AUTH_URL } from '../../../src/configs/AppConfig';
import React, {useState } from "react";
import { MdArrowBackIos } from "react-icons/md";



export default function ForgetPass() {
  const [isLoading , setIsLoading] = useState(false);

  const success = () => {
    message.success('We send you an email to reset your password');
  };
  const errorM = () => {
    message.error('This is email not exist');
  };
  

    return (
      <> 
      <div className="forgetpass-img">
      </div>
    <div className="flex items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start login-inputs">
      {/* Sign in section */}
      <div className="w-full max-w-full flex-col items-center lg:pl-0 ">
       <Link to="/auth/sign-in" className="mt-1 dark:text-white BackLog"> 
       <MdArrowBackIos className=" arrowBac" /> <span>Back to login</span> </Link> 
        <h4 className="login-text">
          forgot your password ?
        </h4>
        <p className="details-text">
          Enter your email to recover your password
        </p>
        <div>

     <Formik
       initialValues={{ email: ''}}
       validate={values => {
         const errors = {};
         if (!values.email) {
           errors.email = 'Required';
         } 
         else if (
           !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
         ) {
           errors.email = 'Invalid email address';
         }
         return errors;
       }}
       onSubmit={(values ,{setSubmitting}) => {
        setIsLoading(true);
       axios.post(`${AUTH_URL}forget-password`, {
          email: values.email.trim(),
        })
        .then(function (response) {
          if(response.data){
            success()
            setIsLoading(false)          }
          if(!response.data){
            errorM()
            setIsLoading(false);
          }
      
        })
        .catch(function (error) {
        //   errorM()
          console.log(error);
          setIsLoading(false);
        });
         }
      }
     >
       {({ isSubmitting }) => (
         <Form>
           <Field type="email" placeholder="Email" name="email" id="email" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`}/>
           <ErrorMessage name="email" component="div" id="erroMassage" />
           {/* <Field type="text" placeholder="Phone" name="phone" id="phone" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`}/>
           <ErrorMessage name="phone" component="div" id="erroMassage" /> */}

           <button type="submit" disabled={isLoading} className="linear w-full py-[12px] text-base transition duration-200 hover:bg-brand-600 active:bg-brand-700 login-btn">
           Submit
           </button>
         </Form>
       )}
     </Formik>
   </div>
      </div>
    </div>
    </>

  );
}
